module.exports = __webpack_public_path__ + "76b326f4d44222126fee21076595bef5.gif";